/* unplugin-vue-components disabled */import script from "./AccountActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountActivity.vue?vue&type=script&setup=true&lang=js"

import "./AccountActivity.vue?vue&type=style&index=0&id=2669cc1c&lang=scss"

const __exports__ = script;

export default __exports__